var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 96,
    viewBox: "0 0 90 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.22842 41.564L20.307 37.2558C20.3233 37.1522 20.3435 37.0485 20.3676 36.9447L25.7513 13.7458L35.3283 11.1796C35.3218 11.2107 35.315 11.2417 35.3078 11.2727L29.8728 34.6927L49.9842 29.3038C49.9901 29.2769 49.9962 29.25 50.0026 29.2231L55.5765 5.75417L65.1805 3.18077C65.1758 3.20218 65.1709 3.22359 65.1658 3.245L59.588 26.7305L86.7901 19.4417L83.0871 5.62189C82.0865 1.88763 78.2482 -0.328451 74.5139 0.672141L5.47516 19.171C1.7409 20.1716 -0.47518 24.01 0.525413 27.7442L4.22842 41.564ZM4.25762 41.564H89.7318V88.5669C89.7318 92.4329 86.5978 95.5669 82.7318 95.5669H11.2576C7.39163 95.5669 4.25762 92.4329 4.25762 88.5669V41.564ZM19.4881 76.5862C19.4881 74.17 21.4468 72.2112 23.8631 72.2112H33.4146C35.8309 72.2112 37.7896 74.17 37.7896 76.5862C37.7896 79.0025 35.8309 80.9612 33.4146 80.9612H23.8631C21.4468 80.9612 19.4881 79.0025 19.4881 76.5862Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.4a5b098d303e5439d05f192e9bc52864.svg";
export { ForwardRef as ReactComponent };